import { OrderStatus } from "Infrastructure/Api/Api";
import { useUpdateOrder } from "Order/Api/Mutation/updateOrderMutation";
import { useUser } from "Settings/User/Api/Query/useUserProfileQuery";
import { toast } from "sonner";

const ROLE_ADMIN = "Admin";
const ROLE_REGIONAL_MANAGER = "Regional Manager";

/**
 * Hook to change order status and make order unfinished.
 *
 * Used when an order marked as done and has service fee invoice
 * needs to be reopened for additional processing.
 */
export function useUnfinishOrder(orderId: number, partnerId?: number) {
	const { user } = useUser();
	const { mutate: updateOrder } = useUpdateOrder(orderId);

	/**
	 * Check if the user has the role of 'Admin' or 'Regional Manager'
	 */
	const isAllowedRole = user?.roles.some(
		(role) => role === ROLE_ADMIN || role === ROLE_REGIONAL_MANAGER,
	);

	/**
	 * Unfinish the order by updating its status and dateDone and sfInvoicePeriod fields.
	 */
	const unfinishOrder = () => {
		if (!isAllowedRole) {
			return toast.warning(
				"You do not have permission to unfinish this order.",
			);
		}

		if (!partnerId) {
			return toast.warning("No partner selected");
		}

		updateOrder({
			unfinishOrder: true,
			sfInvoicePeriod: null,
			dateDone: null,
			status: OrderStatus.in_progress,
			partnerId: partnerId,
		});
	};

	return {
		unfinishOrder,
	};
}
